import React from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { Text } from '~/eds/src/components/Text/Text';
import { BulkActionType } from '~/enums/BulkActionType';
import { actionTypeContent } from '~/utils/bulkActionLimits';

interface Props {
  limit: number;
  count: number;
  actionType: BulkActionType;
  isVisible: boolean;
  hideModal: () => void;
}

/* This component can eventually hopefully be deprecated in favor of using `useLimitExceededModal` hook
 * once our legacy class components such as DocumentsPage are replaced with functional components. */
const LimitExceededModal = ({
  limit,
  count = 0,
  actionType,
  isVisible = false,
  hideModal,
}: Props) => {
  const intl = useIntl();

  const children = (
    <Layout spacing={3}>
      <Icon color="status.warning" icon="status-warning" size="l" />
      <Text>
        {intl.formatMessage(
          {
            id: 'LimitExceededModal.limitExceededMessage',
            defaultMessage:
              'Only {limit} documents can be {actionType} at a time. Please select fewer documents to complete this action.',
            description:
              'Message explaining document limit exceeded. Example: limit = "100", actionType = "moved"',
          },
          {
            limit,
            actionType: actionTypeContent(actionType, intl),
          },
        )}
      </Text>
    </Layout>
  );

  return (
    <Modal
      title={intl.formatMessage(
        {
          id: 'LimitExceededModal.modalTitle',
          defaultMessage: 'Documents limit exceeded, current limit: {count}',
          description:
            'Modal title showing limit exceeded for bulk action. Example: count = "5"',
        },
        {
          count,
        },
      )}
      isVisible={isVisible}
      onHide={hideModal}
      onCancel={null}
      primaryAction={{
        text: intl.formatMessage({
          id: 'LimitExceededModal.gotItButton',
          defaultMessage: 'Got it',
          description: 'Button text to acknowledge limit exceeded message',
        }),
        variant: 'primary',
        onClick: hideModal,
      }}
      children={children}
    />
  );
};

export default LimitExceededModal;
